import React from "react";
import { Breadcrumb, Button } from "react-bootstrap";
import PaginationBar from "../../PaginationBar";
import { LinkContainer } from "react-router-bootstrap";
import {connect} from "react-redux";
import Loading from "components/Loading";
import Request from "request";
import ClientTable from "./ClientTable";

class EpisodeClients extends React.Component {
	state = {
		isLoading: false,
		clients: null,
		activePage: 1
	};

	componentDidMount() {
		this.fetchData();
	}

	UNSAFE_componentWillReceiveProps() {
		this.fetchData();
	}

	fetchData() {
		const {event} = this.props;
		const {episodeKey} = this.props.match.params;

		this.setState({isLoading: true});
		Request.get(`/api/cp/event/${event.eventPassword}/statistic/episode/${episodeKey}/clients`)
			.then(clients => this.setState({clients, activePage: 1}))
			.catch(() => {})
			.then(() => this.setState({isLoading: false}))
		;
	}

	render() {
		const clientsOnPage = 100;
		const {event} = this.props;
		const {episodeKey} = this.props.match.params;
		const {clients, isLoading, activePage} = this.state;

		if(isLoading) return <Loading>Загрузка статистики эпизода</Loading>;
		if(!clients) return <div>Данные статистики не найдены</div>;

		var clientsFiltered = clients;

		var pageCount = Math.ceil(clientsFiltered.length / clientsOnPage);
		clientsFiltered = clientsFiltered.slice((activePage - 1) * clientsOnPage, activePage * clientsOnPage);

		return (
			<section className="statistic">
				<Breadcrumb>
					<LinkContainer to={`/event/${event.eventPassword}`}><Breadcrumb.Item>Трансляция</Breadcrumb.Item></LinkContainer>
					<LinkContainer to={`/event/${event.eventPassword}/statistic`}><Breadcrumb.Item>Статистика</Breadcrumb.Item></LinkContainer>
					<Breadcrumb.Item active>Зрители эпизода</Breadcrumb.Item>
				</Breadcrumb>

				<div style={{textAlign: 'right'}}>
					<Button href={`/api/cp/event/${event.eventPassword}/statistic/episode/${episodeKey}/clients.xlsx`}>Скачать</Button>
				</div>

				<ClientTable clients={clientsFiltered} event={event} full/>

				<PaginationBar
					pageCount={pageCount}
					activePage={activePage}
					onSelect={(activePage) => this.setState({activePage})}
				/>
			</section>
		);
	}
}

const mapStateToProps = (store) => {
	return {
		event: store.currentEvent
	}
};

export default connect(mapStateToProps)(EpisodeClients);
